import { Flow } from 'signup-constants/Flow';
import { isFlow } from '../utils/isFlow';
import { getIsAuthenticated } from '../store/auth/selectors';
import { isExistingUser, isExistingUserExistingAccount } from '../app/verificationTypeSelectors';
import { getHasPaidProducts } from '../store/portal-tier/selectors';
export const shouldSkipHublet = () => {
  return isFlow([Flow.Sales, Flow.Service, Flow.Marketing, Flow.CmsFree, Flow.Crm, Flow.HubspotForStartups, Flow.HubSpotPartners, Flow.ClassroomTraining, Flow.StandaloneCmsPartner, Flow.SolutionsProvider, Flow.Commerce, Flow.FbCrm, Flow.Microapp, Flow.Integrations, Flow.AssetProvider, Flow.Developers, Flow.CmsDevelopers, Flow.Academy, Flow.DirectoryListing]);
};
export const shouldAddHubletStep = state => {
  return getIsAuthenticated(state) && !isExistingUserExistingAccount(state) && getHasPaidProducts(state) && isExistingUser(state);
};
export const shouldPrefillHubletAutomatically = () => {
  return isFlow([Flow.Sales, Flow.Service, Flow.Marketing, Flow.CmsFree, Flow.Crm, Flow.HubspotForStartups, Flow.HubSpotPartners, Flow.ClassroomTraining, Flow.StandaloneCmsPartner, Flow.SolutionsProvider, Flow.Commerce, Flow.FbCrm, Flow.AssetProvider, Flow.Microapp, Flow.Integrations]);
};
export const shouldUseIPForHublet = state => {
  return isFlow([Flow.Developers, Flow.CmsDevelopers, Flow.Academy, Flow.DirectoryListing]) && shouldAddHubletStep(state);
};
export const shouldUseIPForHubletFlow = () => {
  return isFlow([Flow.Developers, Flow.CmsDevelopers, Flow.Academy, Flow.DirectoryListing]);
};